/* Relax Master — Collectiepagina Massageolie: filter, sorteren, olietest, carrousel, FAQ */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.rm-col');
    if (!root) return;

    /* ---------------- Filter + sorteren ---------------- */
    var grid = root.querySelector('[data-rm-grid]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-rm-card]')) : [];
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-rm-filter]'));
    var sortSel = root.querySelector('[data-rm-sort]');
    var countEl = root.querySelector('[data-rm-count]');
    var state = { filter: 'alle', sort: 'aanbevolen' };

    function applyFilterChipStyles() {
      chips.forEach(function (c) {
        var on = c.getAttribute('data-rm-filter') === state.filter;
        c.style.background = on ? '#2d4947' : '#ffffff';
        c.style.color = on ? '#ffffff' : '#5b6661';
        c.style.borderColor = on ? '#2d4947' : '#ddd6c6';
      });
    }

    function render() {
      var visible = cards.filter(function (card) {
        if (state.filter === 'alle') return true;
        var use = (card.getAttribute('data-use') || '').split(' ');
        return use.indexOf(state.filter) !== -1;
      });

      visible.sort(function (a, b) {
        if (state.sort === 'laag') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (state.sort === 'hoog') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        return parseFloat(a.dataset.ord) - parseFloat(b.dataset.ord);
      });

      cards.forEach(function (c) { c.style.display = 'none'; });
      visible.forEach(function (c, i) {
        c.style.display = '';
        c.style.order = i;
        c.style.animationDelay = (i * 40) + 'ms';
      });
      if (countEl) countEl.textContent = visible.length + (visible.length === 1 ? ' product' : ' producten');
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        state.filter = c.getAttribute('data-rm-filter');
        applyFilterChipStyles();
        render();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); });
    applyFilterChipStyles();
    render();

    /* ---------------- Olietest (quiz) ---------------- */
    var quizMount = root.querySelector('[data-rm-quiz]');
    var quizDataEl = document.getElementById('rm-quiz-data');
    if (quizMount && quizDataEl) {
      var data = {};
      try { data = JSON.parse(quizDataEl.textContent); } catch (e) { data = {}; }
      var quiz = data.quiz || [];
      var oils = data.oils || {};
      var oilKeys = data.oilKeys || [];
      var why = data.why || {};
      var answers = [];

      function renderQuestion() {
        var total = quiz.length;
        var step = Math.min(answers.length, total - 1);
        var num = Math.min(answers.length + 1, total);
        var pct = Math.round((answers.length / total) * 100);
        var q = quiz[step];
        var opts = q.opts.map(function (o, j) {
          return '<button type="button" class="quiz-opt" data-opt="' + j + '" style="cursor:pointer;font-family:\'Montserrat\',sans-serif;display:flex;align-items:center;justify-content:space-between;gap:14px;width:100%;text-align:left;padding:17px 20px;border:1px solid #ece7dd;border-radius:14px;background:#fff;font-size:15px;font-weight:500;color:#2d4947;">' +
            o.label +
            '<span class="quiz-dot" style="flex:none;width:22px;height:22px;border-radius:50%;border:2px solid #ddd6c6;transition:background .15s,border-color .15s;"></span></button>';
        }).join('');

        quizMount.innerHTML =
          '<div>' +
            '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;">' +
              '<span style="font-size:12px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#a97e35;">Vraag ' + num + ' van ' + total + '</span>' +
            '</div>' +
            '<div style="height:5px;border-radius:4px;background:#efe7d6;overflow:hidden;margin-bottom:28px;">' +
              '<div style="height:100%;width:' + pct + '%;background:#a97e35;border-radius:4px;transition:width .3s ease;"></div>' +
            '</div>' +
            '<h3 style="margin:0 0 22px;font-family:\'Quiche Sans\',serif;font-size:25px;font-weight:600;color:#2d4947;line-height:1.2;">' + q.q + '</h3>' +
            '<div style="display:flex;flex-direction:column;gap:12px;">' + opts + '</div>' +
          '</div>';

        quizMount.querySelectorAll('[data-opt]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            answers.push(parseInt(btn.getAttribute('data-opt'), 10));
            if (answers.length >= total) renderResult();
            else renderQuestion();
          });
        });
      }

      function renderResult() {
        var scores = {};
        oilKeys.forEach(function (k) { scores[k] = 0; });
        answers.forEach(function (oi, qi) {
          var sm = quiz[qi].opts[oi].s || {};
          Object.keys(sm).forEach(function (k) { scores[k] = (scores[k] || 0) + sm[k]; });
        });
        var best = oilKeys[0], bestV = -1;
        oilKeys.forEach(function (k) { if (scores[k] > bestV) { bestV = scores[k]; best = k; } });
        var o = oils[best] || {};

        quizMount.innerHTML =
          '<div class="quiz-result" style="display:grid;grid-template-columns:230px 1fr;gap:36px;align-items:center;">' +
            '<div style="position:relative;height:250px;border-radius:16px;overflow:hidden;background:#f6f1e8;border:1px solid #ece7dd;">' +
              '<div class="rm-bg" style="position:absolute;inset:0;background-image:url(\'' + o.img + '\');background-size:cover;background-position:center;"></div>' +
            '</div>' +
            '<div>' +
              '<span style="font-size:12px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#a97e35;">Jouw match</span>' +
              '<h3 style="margin:10px 0 0;font-family:\'Quiche Sans\',serif;font-size:28px;font-weight:600;color:#283631;line-height:1.15;">' + o.name + '</h3>' +
              '<p style="margin:12px 0 18px;font-size:15px;font-weight:300;line-height:1.65;color:#5b6661;">' + (why[best] || '') + '</p>' +
              '<div style="display:flex;align-items:center;gap:18px;flex-wrap:wrap;">' +
                '<a href="' + o.href + '" class="gold-btn" style="display:inline-flex;align-items:center;gap:9px;padding:14px 28px;border-radius:30px;background:#a97e35;color:#fff;font-size:14px;font-weight:500;text-decoration:none;">Bekijk deze olie · ' + o.price + '</a>' +
                '<button type="button" data-restart style="cursor:pointer;font-family:\'Montserrat\',sans-serif;background:none;border:none;font-size:14px;font-weight:500;color:#6b7269;text-decoration:underline;text-underline-offset:3px;">Opnieuw doen</button>' +
              '</div>' +
            '</div>' +
          '</div>';

        var rb = quizMount.querySelector('[data-restart]');
        if (rb) rb.addEventListener('click', function () { answers = []; renderQuestion(); });
      }

      if (quiz.length) renderQuestion();
    }

    /* ---------------- Cross-sell carrousel ---------------- */
    var scroller = root.querySelector('.rm-scroll');
    function animateScroll(delta) {
      if (!scroller) return;
      var start = scroller.scrollLeft;
      var target = Math.max(0, Math.min(start + delta, scroller.scrollWidth - scroller.clientWidth));
      var t0 = performance.now();
      function step(t) {
        var p = Math.min(1, (t - t0) / 360);
        var e = 1 - Math.pow(1 - p, 3);
        scroller.scrollLeft = start + (target - start) * e;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var prev = root.querySelector('[data-rm-scroll-prev]');
    var next = root.querySelector('[data-rm-scroll-next]');
    if (prev) prev.addEventListener('click', function () { animateScroll(-560); });
    if (next) next.addEventListener('click', function () { animateScroll(560); });

    /* ---------------- FAQ accordeon ---------------- */
    root.querySelectorAll('[data-rm-faq]').forEach(function (item) {
      var head = item.querySelector('[data-rm-faq-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        root.querySelectorAll('[data-rm-faq]').forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
